export var SDK_VERSION = '6.7.1';
//# sourceMappingURL=version.js.map